import React, { useEffect, useState } from 'react'
import { QRCodeSVG } from 'qrcode.react';
import moment from 'moment/moment';
import store from '../../store';
import { updateLoader } from '../../actions/search-actions';
import { GetRequest, PostRequest, bookAgain, getDateFormatIPhone } from '../common/helper';
import AlertSuccess from '../common/alertSuccess';
import AlertFail from '../common/alertFail';
import { apiUrl } from '../common/constants';
import { renderImg } from '../common/icons/img';
import AccountLoader from './accountLoader';

const ViewBooking = ({ pnr, type, returnBooking, mobile, pnrTicket = false }) => {
  const [viewBookingData, setViewBookingData] = useState({})
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [emailFailed, setEmailFailed] = useState(false);
  const [linkTicketMsg, setLinkTicketMsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const [txnPwd, setTxnPwd] = useState("");
  const[paymentGateway,setPaymentGateway] = useState("");
  const [qrImg, setQrImg] = useState("");
  const [mob, setMob] = useState(mobile);
  const [token, setToken] = useState("");
  const [refund, setRefundData] = useState({});
  const [refundDetail, setRefundDetail] = useState({});

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    setLoader(true);
    const url = `${window.url}/api/resource/BookingInfo?PNR=${pnr}&mobile=${mob}`;
    try {
      const response = await fetch(url);
      // store.dispatch(updateLoader(false));
      try {
        const data = await response.json();
        if (data.Status == true) {
          if (data.BookingInfo.APIGetBookingDetailsResult.length > 0) {
            getQrImg(data.BookingInfo.APIGetBookingDetailsResult[0]);
            setViewBookingData(data.BookingInfo.APIGetBookingDetailsResult[0] || {})
            setRefundData(data.BookingInfo.APIGetBookingDetailsResult[0].RefData[0] || {})
            setRefundDetail(data.BookingInfo.APIGetBookingDetailsResult[0].RefundDetail[0] || {})
            let orderId = data.BookingInfo.APIGetBookingDetailsResult[0].OrderID.split('_')[1] ? data.BookingInfo.APIGetBookingDetailsResult[0].OrderID.split('_')[1] : data.BookingInfo.APIGetBookingDetailsResult[0].OrderID;
            getTxnPwd(orderId, data.BookingInfo.APIGetBookingDetailsResult[0].BookingRefNo);
            getToken(data.BookingInfo.APIGetBookingDetailsResult[0].BookingRefNo,data.BookingInfo.APIGetBookingDetailsResult[0].PassengerContactNo1);
          } else {
            setViewBookingData([]);
            setRefundData([]);
            setRefundDetail([]);
          }
        }
        else {
          setViewBookingData([]);
          setRefundData([]);
          setRefundDetail([]);
        }
        setLoader(false);
      } catch (error) {
        // store.dispatch(updateLoader(false));
        setLoader(false);
        return false;
      }
    }
    catch (err) {
      // store.dispatch(updateLoader(false));
      setLoader(false);
      return err;
    }
  }

  useEffect(()=>{
    if(Number(viewBookingData.IsLinkBooking) == 1 && pnrTicket == true){
      setLinkTicketMsg(true);
    }
  },[viewBookingData])

  const getTxnPwd = (orderId, pnr) => {
    setLoader(true);
    const url = `${apiUrl.getTxnPwd}?order_id=${orderId}&pnrNo=${pnr}`;
    GetRequest(url).then(res => {
      console.log("res")
      setTxnPwd(res.txn_pwd);
      setPaymentGateway(res.paymentGateway);
    }).catch(err => {
      setLoader(false);
      console.log(err);
    })
  }

  const getToken = (pnr,mobile) => {
    const url = `${apiUrl.getToken}?val=${pnr}&mobile=${mobile}`;
    GetRequest(url).then(res => {
      if (res.Success)
        setToken(res.token);
      else
        setToken("")
    }).catch(err => {
      console.log(err);
    })
  }

  const getQrImg = (bookingData) => {
    const url = `${apiUrl.genQrImg}`;
    const seats = [];
    const names = [];
    const gender = [];
    const age = [];
    const PaxDetail = bookingData.PaxDetail;
    if (PaxDetail && PaxDetail.length > 0) {
      for (let i = 0; i < PaxDetail.length; i++) {
        seats.push(PaxDetail[i].SeatNo);
        names.push(PaxDetail[i].PaxName);
        gender.push(PaxDetail[i].Gender);
        age.push(PaxDetail[i].Age);
      }
    }
    const data = {
      Pnr: bookingData.BookingRefNo,
      Email: bookingData.PassengerEmail,
      Mobile: bookingData.PassengerContactNo1,
      Seats: seats,
      Names: names,
      Gender: gender,
      Age: age,
      TripCode: bookingData.TripCode,
      JourneyDate: bookingData.JourneyDate,
      FromCity: bookingData.FromCityName,
      ToCity: bookingData.ToCityName,
      PickupName: bookingData.PickupName,
      DropOffName: bookingData.DropoffName,
    };
    setLoader(true);
    PostRequest(url, data)
      .then((res) => {
        if (res.Success) {
          setLoader(false);
          setQrImg(res.qrImg);
        } else {
        }
      })
      .catch((err) => { setLoader(false); });
  }

  const print = () => {
    //console.log('print');  
    let printContents = document.getElementById('print_div').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  const handelSendTicket = (data,mobile) => {
    setLoader(true);
    const url = apiUrl.sendBookingTicket + `?pnrNo=${data?.BookingRefNo}&mobile=${mobile}`;
    GetRequest(url)
      .then((res) => {
        if (res?.Success) {
          setEmailSuccess(true)
        } else if (res?.error) {
          setErrorMsg(res.error);
          setEmailFailed(true);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }

  const getTotalSeatlabel = (passenger) => {
    let label = '';
    let child = 0;
    let adult = 0;
    //let seniorCitizen = 0;
    if (passenger && passenger.length > 0) {
      for (let i = 0; i < passenger.length; i++) {
        if (passenger[i].Age > 11) {
          adult += 1;
        } else {
          child += 1
        }
      }
      label = `${passenger.length} (Adults : ${adult} Children : ${child})`;
    }
    return label;
  }

   const getLevy = (fare) => {
        const {
            BridgeFee = 0,
            EntryFee = 0,
            InfraFee = 0,
            InsuranceFee = 0,
            TollFee = 0,
            UserFee = 0,
        } = fare;
        return (
            BridgeFee + EntryFee + InfraFee + InsuranceFee + TollFee + UserFee
        );
    };

    const getLevyRefund = (fare) => {
        const {
            BridgeFee = 0,
            EntryFee = 0,
            InfraFee = 0,
            InsuranceFeee = 0,
            TollFee = 0,
            UserFee = 0,
        } = fare;
        return (
            BridgeFee + EntryFee + InfraFee + InsuranceFeee + TollFee + UserFee
        );
    };

  console.log("type", type);
  console.log("returnBooking", returnBooking)
  return (
    <>
      {loader && <AccountLoader />}
      <div className="viewBooking-content" id="print_div">
        <div className="viewBkg-header">
          {
           Number(viewBookingData.IsLinkBooking) == 1 ? 
              (Number(viewBookingData.IsFirstLeg) == 1 ?
                <div>ಪ್ರಾರಂಭದ ಪ್ರಯಾಣದ ಟಿಕೇಟ್ ವಿವರಗಳು / Start Trip Ticket Details</div>
                :
                <div>ಸಂಪರ್ಕ ಪ್ರಯಾಣದ ಟಿಕೇಟ್ ವಿವರಗಳು / Connecting Trip Ticket Details</div>) 
              : 
              (viewBookingData.OnwardBooking == 0 ?
                <div>ಪ್ರಯಾಣ ಟಿಕೇಟ್ ವಿವರಗಳು / Onward Journey Ticket Details</div>
                :
                <div>ಪ್ರಯಾಣ ಟಿಕೇಟ್ ವಿವರಗಳು / Return Journey Ticket Details</div>)
          }

          <div>ಇ-ಟಿಕೆಟ್ ಅಡ್ವಾನ್ಸ್ ರಿಸರ್ವೇಶನ್/e-Ticket Advance Reservation</div>

        </div>
        <div className="viewBkg-logo">
          <div className='content-logo'>
            <div>
              <img src="https://microsites-websitebuilder.s3.ap-southeast-1.amazonaws.com/images/ksrtc_logo_view.png" alt="" className='logo' />
            </div>
            <div className='address-info'>
              <p>ಕರ್ನಾಟಕ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ ನಿಗಮ / KARNATAKA STATE ROAD TRANSPORT CORPORATION</p>
              <p>ಕೇಂದ್ರ ಕಛೇರಿ, ಸಾರಿಗೆ ಭವನ, ಕೆ ಹೆಚ್ ರಸ್ತೆ, ಬೆಂಗಳೂರು -560027, ಕರ್ನಾಟಕ, ಭಾರತ /
                CENTRAL OFFICE, TRANSPORT HOUSE, K.H ROAD, BENGALURU - 560027, KARNATAKA, INDIA.</p>
              <p>ದೂರವಾಣಿ ಸಂಖ್ಯೆ / Telephone No: 08026252625</p>
              <p>ಮುಖಪುಟ / Homepage : <a href="https://www.ksrtc.in" style={{ color: "var(--ksrtcThColor1)", textDecoration: "underline" }}>www.ksrtc.in</a></p>
              <p>{viewBookingData?.CorporationCode} GSTIN : {viewBookingData?.CorporationGSTN}</p>
            </div>
          </div>
          <div className="qrCode">
            <h4> Boarding QR</h4>
            {/* <QRCodeSVG value={viewBookingData.PNRNo} />, */}
            {
              qrImg &&
              <img style={{ width: '98px', height: '98px' }} src={qrImg} alt='qr_img' />
            }
          </div>
        </div>
        <div className="tableViewContent">
          <div className="firstTable">
            <table width="100%">
              <colgroup>
                <col width="49%" />
                <col width="2%" />
                <col width="49%" />
              </colgroup>
              <tr>
                <td>ಪಿಎನ್‍ಆರ್ ಸಂಖ್ಯೆ / PNR No.</td>
                <td>:</td>
                <td>{viewBookingData.BookingRefNo || ""}</td>
              </tr>
              <tr>
                <td>ಟ್ರಿಪ್‍ಕೋಡ್ / Trip Code.</td>
                <td>:</td>
                <td>{viewBookingData.TripCode || ""}</td>
              </tr>
              <tr>
                <td>ಪ್ರಾರ೦ಭ ಸ್ಥಳ / Start Place</td>
                <td>:</td>
                <td>{viewBookingData.FromCityName || ""}</td>
              </tr>
              <tr>
                <td>ನಿರ್ಗಮನ ಸಮಯ / Departure Time</td>
                <td>:</td>
                <td><strong>{viewBookingData.PickupDate && getDateFormatIPhone(viewBookingData.PickupDate, "HH:mm") || ""} Hrs</strong></td>
              </tr>
              <tr>
                <td>ಒಟ್ಟು ಆಸನಗಳು / Total Seats</td>
                <td>:</td>
                <td>{getTotalSeatlabel(viewBookingData.PaxDetail)}</td>
              </tr>
              <tr>
                <td>ವ್ಯವಹಾರ ಗುಪ್ತಪದ / Txn. Password</td>
                <td>:</td>
                <td><strong>{txnPwd}</strong></td>
              </tr>
              <tr>
                <td>ಓಬಿ ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ / OB Ref. No.</td>
                <td>:</td>
                <td>{viewBookingData.OrderID}</td>
              </tr>
              <tr>
                <td>ಸ್ಥಿತಿಗತಿ / Status.</td>
                <td>:</td>
                <td>
                  {viewBookingData.BookingStatus === 'B'
                    ?
                    <label className='BKG-status-green'>CONFIRMED</label>
                    :
                    <label className='BKG-status-green' style={{ color: 'red' }}>CANCELLED</label>
                  }
                </td>
              </tr>
              <tr>
                <td>ಗ್ರಾಹಕರ ಜಿ.ಎಸ್.ಟಿ / Customer GSTIN</td>
                <td>:</td>
                <td>{viewBookingData.CustomerGSTNO}</td>
              </tr>
              {
                Number(viewBookingData.IsLinkBooking) == 1 && (
                  <tr>
                    <td>ಪ್ರಯಾಣದ ಪ್ರಕಾರ / Journey Type</td>
                    <td>:</td>
                    <td>Link Journey</td>
                  </tr>
                )
              }
            </table>
          </div>
          <div className="secondTable">
            <table width="100%">
              <colgroup>
                <col width="49%" />
                <col width="2%" />
                <col width="49%" />
              </colgroup>
              <tr>
                <td>ಪ್ರಯಾಣದ ದಿನಾಂಕ / Date of Journey</td>
                <td>:</td>
                <td>{viewBookingData.JourneyDate && moment(viewBookingData.JourneyDate).format("DD-MMM-YYYY") || ""}</td>
              </tr>
              <tr>
                <td>ಸಾರಿಗೆಯ ವರ್ಗ / Service Category</td>
                <td>:</td>
                <td>{viewBookingData.ServiceTypeName || ""}</td>
              </tr>
              <tr>
                <td>ಪ್ರಯಾಣಿಕರು ಹತ್ತುವ ಸ್ಥಳ/ Boarding Point</td>
                <td>:</td>
                <td><strong>{viewBookingData.PickupName || ""}</strong></td>
              </tr>
              <tr>
                <td>ಅಂಕಣ ಸಂಖ್ಯೆ / Platform No.</td>
                <td>:</td>
                <td>{viewBookingData.PlatFormNo}</td>
              </tr>
              <tr>
                <td>ಪ್ರಯಾಣಿಕರು ಇಳಿಯುವ ಸ್ಥಳ/ Dropping Point</td>
                <td>:</td>
                <td><strong>{viewBookingData.DropoffName || ""}</strong></td>
              </tr>
              <tr>
                <td>ಸಾರಿಗೆಯ ಸ್ಥಿತಿಗತಿ / Service Status</td>
                <td>:</td>
                <td><strong>Operation</strong></td>
              </tr>
              <tr>
                <td>ಒಂಟಿ ಮಹಿಳೆ ಟಿಕೇಟ್ / Is Single Lady Ticket</td>
                <td>:</td>
                <td>No</td>
              </tr>
              <tr>
                <td>ಬ್ಯಾಂಕಿನ ಹೆಸರು / Bank Name</td>
                <td>:</td>
                {/* <td>{"Razorpay" || ""}</td> */}
                <td>{paymentGateway}</td>
              </tr>
            </table>
          </div>
        </div>
        <div className='passenger-detail-wrapper'>
          {
           Number(viewBookingData.IsLinkBooking) == 1 ? 
              (Number(viewBookingData.IsFirstLeg) == 1 ?
                <h3>ಪ್ರಾರಂಭದ ಪ್ರಯಾಣದ ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು / Start Trip Passenger Details</h3>
                :
                <h3>ಸಂಪರ್ಕ ಪ್ರಯಾಣದ ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು / Connecting Trip Passenger Details</h3>) 
              : 
              (viewBookingData.OnwardBooking == 0 ?
                <h3>ಪ್ರಯಾಣಿಕರ  ಹೋಗುವ  ಟ್ರಿಪನ / Onward Trip Passenger Details</h3>
                :
                <h3>ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು / Return Trip Passenger Details</h3>)
          }
          <div className="table">
            <table>
              <thead>
                <tr>
                  <td>ಆಸನ ಸಂಖ್ಯೆ /<br />Seat No.</td>
                  <td>ಹೆಸರು /<br /> Passenger Name</td>
                  <td>ವಯಸ್ಸು / <br />Age</td>
                  <td>ವಯಸ್ಕರು / ಮಕ್ಕಳು /<br /> Adult / Child</td>
                  <td>ಲಿಂಗ /<br />Gender</td>
                  <td>ರಿಯಾಯಿತಿ  ವಿಧ /<br />Concession Type</td>
                  <td>ರಾಷ್ಟ್ರೀಯತೆ /<br />Nationality</td>
                </tr>
              </thead>
              <tbody>
                {
                  viewBookingData.PaxDetail &&
                    viewBookingData.PaxDetail.length > 0 ?
                    viewBookingData.PaxDetail.map((val, i) => {
                      return (
                        <tr key={i}>
                          <td>{val.SeatNo}</td>
                          <td>{val.PaxName}</td>
                          <td>{val.Age}</td>
                          <td>{val.Age > 11 ? "Adult" : "Child"}</td>
                          <td>{val.Gender == "F" ? "Female" : "Male"}</td>
                          <td>{val.ConcessionTypeName}</td>
                          <td>{val.Nationality}</td>
                        </tr>
                      )
                    }) : ""
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className='trip-fare-wrapper'>
          {
           Number(viewBookingData.IsLinkBooking) == 1 ? 
              (Number(viewBookingData.IsFirstLeg) == 1 ?
                <h3>ಪ್ರಾರಂಭದ ಪ್ರಯಾಣದ ದರದ ವಿವರಗಳು / Start Trip Fare Breakup</h3>
                :
                <h3>ಸಂಪರ್ಕ ಪ್ರಯಾಣದ ದರದ ವಿವರಗಳು / Connecting Trip Fare Breakup</h3>) 
            : 
              (viewBookingData.OnwardBooking == 0 ?
                <h3>ಹೋಗುವ ಪ್ರಯಾಣದ ದರಡ ವಿಂಗಡಣೆ / Onward Trip Fare Breakup</h3>
                :
                <h3>ಹಿಂದಿರುಗುವ ಪ್ರಯಾಣ ದರದ ವಿರಾಮ / Return Trip Fare Breakup</h3>)
          }
          <table className="ownerTrip-table">
            <tbody>
              <tr>
                <td>ಮೂಲ ದರ / Basic Fare</td>
                <td className="txtRt">₹{viewBookingData.TotalFare || 0}</td>
              </tr>
              <tr>
                <td>ರಿಯಾಯಿತಿ ಮೊತ್ತ / Concession Amount</td>
                <td className="txtRt">-₹{viewBookingData.ConcessionAmount}</td>
              </tr>
              <tr>
                <td>ರಿಯಾಯಿತಿ / Discount</td>
                <td className="txtRt">-₹{viewBookingData.TotalDiscount}</td>
              </tr>
              <tr>
                <td>ಕಾಯ್ದಿರಿಸುವಿಕೆ ಶುಲ್ಕ Rs. / Reservation Fee Rs.</td>
                <td className="txtRt">₹{viewBookingData.SRTFee}</td>
              </tr>
              {/* <tr>
                <td>ಸ.ಸೇ.ಶು / GST</td>
                <td>₹{viewBookingData.Tax}</td>
              </tr>
              <tr>
                <td>ಪಾವತಿ ಗೇಟ್‍ವೇ ಶುಲ್ಕ ಗಳಲ್ಲಿ / Payment Gateway Charges</td>
                <td>₹0</td>
              </tr> */}
              <tr>
                <td>ಇತರೆ ಶುಲ್ಕಗಳು / Levies</td>
                <td className="txtRt">₹{(viewBookingData.BridgeFee + viewBookingData.InfraFee + viewBookingData.InsuranceFee + viewBookingData.UserFee + viewBookingData.TollFee + viewBookingData.EntryFee + viewBookingData.Tax) || 0}</td>
              </tr>
              <tr>
                <td>(GST: {viewBookingData.Tax};  USER :{viewBookingData.UserFee}; ARF :{viewBookingData.InsuranceFee}; INFRA:{viewBookingData.InfraFee}; TOLL:{viewBookingData.TollFee}; BRIDGE:{viewBookingData.BridgeFee}; ENTRY:{viewBookingData.EntryFee}; )</td>
                <td></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>ಒಟ್ಟು ಪ್ರಯಾಣದ ದರ / Total Fare</td>
                <td className="txtRt">₹{viewBookingData.TotalAmountPaid}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        {/* <div className="bordingDrop-point">
        <h3>ಬೋರ್ಡಿಂಗ್/ಡ್ರಾಪಿಂಗ್ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ಮಾರ್ಪಡಿಸಿ / Boarding/Droping Points</h3>
        <div className="inputs">
          <div>
            <label>Pickup From </label>
            <input type="text" disabled={true} />
          </div>
          <div>
            <label>Drrop To </label>
            <input type="text" disabled={true} />
          </div>
        </div>
      </div> */}
      {viewBookingData.BookingStatus === 'C' && (
      <>
      <div className='refund-detail-wrapper'>
          <h3>ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು / Refund Break up</h3>
          <div className="table">
            <table width="100%">
              <colgroup>
               <col width="40%"/>
               <col width="19%"/>
               <col width="19%"/>
               <col width="22%"/>
              </colgroup>
              <thead>
                <tr>
                  <td>ವಿವರಣೆ / <br /> Description</td>
                  <td  className="txtRt">ಮೂಲ ವಹಿವಾಟು (₹) / <br /> Original Transaction (₹)</td>
                  <td  className="txtRt">ಮರುಪಾವತಿಸಲು (₹) / <br /> To Be Refunded (₹)</td>
                  <td  className="txtRt">ರದ್ದತಿ ಶೇಕಡಾವಾರು (%) / <br /> Cancellation Percentage (%)</td>
                </tr>
              </thead>
              <tbody>
                  <tr>
                    <td>ಪ್ರಯಾಣ ದರ / Journey Fare</td>
                    <td className="txtRt">{viewBookingData?.TotalBaseFare}</td>
                    <td className="txtRt">{refund?.BaseFare}</td>
                    <td className="txtRt">{refund.ChargePct}%</td>
                  </tr>
                  <tr>
                      <td>ಮೀಸಲಾತಿ ಶುಲ್ಕ / Reservation Fee</td>
                      <td className="txtRt">{viewBookingData?.SRTFee}</td>
                      <td className="txtRt">{refund.SRTFee}</td>
                      <td className="txtRt">{"-"}</td>
                  </tr>
                  <tr>
                      <td>ಇತರೆ ಲೆವಿಗಳು / Other Levies</td>
                      <td className="txtRt">{getLevy(viewBookingData)}</td>
                      <td className="txtRt">{getLevyRefund(refund)}</td>
                      <td className="txtRt">{"-"}</td>
                  </tr>
                  <tr>
                      <td>ಜಿಎಸ್ಟಿ / GST</td>
                      <td className="txtRt">{viewBookingData.Tax}</td>
                      <td className="txtRt">{refund.Gst}</td>
                      <td className="txtRt">{"-"}</td>
                  </tr>
                  <tr>
                      <td>ಕಡಿಮೆ ರಿಯಾಯಿತಿ / Less Discount</td>
                      <td className="txtRt">{viewBookingData.ConcessionAmount}</td>
                      <td className="txtRt">{refund.ConcessionAmount}</td>
                      <td className="txtRt">{"-"}</td>
                  </tr>
                  <tr>
                      <td>ಪಾವತಿ ಗೇಟ್‌ವೇ ಶುಲ್ಕಗಳು / Payment Gateway Charges</td>
                      <td className="txtRt">{0}</td>
                      <td className="txtRt">0</td>
                      <td className="txtRt">{"-"}</td>
                  </tr>
              </tbody>
              <tfoot>
                  <tr>
                      <td>ಒಟ್ಟು / Total</td>
                      <td className="txtRt">{viewBookingData.TotalAmountPaid}</td>
                      <td className="txtRt">{refund.RefundAmountNet}</td>
                      <td className="txtRt">{"-"}</td>
                  </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div className='refund-detail-wrapper btmGap'>
          <h3>ಮರುಪಾವತಿ ವಿವರ / Refund Details</h3>
          <div className="table">
            <table width="100%">
              <colgroup>
                <col width="28%"/>
                <col width="17%"/>
                <col width="25%"/>
                <col width="15%"/>
                <col width="15%"/>
              </colgroup>
              <thead>
                <tr>
                  <td className="txtVt">ಪೇಮೆಂಟ್‌ ಗೇಟ್‌ ವೇ ಮರುಪಾವತಿ ಐಡಿ /<br/> PGW Refund ID</td>
                  <td className="txtVt">ಮುಪಾವತಿ ಮೊತ (₹) / <br/> Refund Amount (₹)</td>
                  <td className="txtVt">ಮರುಪಾವತಿ ದಿನ ಮತ ಸಮಯ / <br/> Refund Creation Date and Time</td>
                  <td className="txtVt">ಮರುಪಾವತಿ ಸ್ಥಿತಿ <br/> Refund Status</td>
                  <td className="txtVt">ARN/RRN/UTR</td>
                </tr>
              </thead>
              <tbody>
                  {refundDetail?.RefAmount ?
                  (<tr>
                    <td>{refundDetail?.PGTransactionID}</td>
                    <td>{refundDetail?.RefAmount}</td>
                    <td>{refundDetail?.RefundInitDate}</td>
                    <td>{refundDetail?.RefStatus}</td>
                    <td>{refundDetail?.ARN}</td>
                  </tr>) : 
                  (<tr>
                    <td colspan="5" className="txtCt">No refund details present !</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        </>
        )}
        {viewBookingData.BookingStatus !== 'C' && (
        <>
          <div className="idProof-node">
            <h3>ಗುರುತಿನ ಚೀಟಿ ಸೂಚನೆ / ID Proof Note</h3>
            <div className="node">
              ಇ-ಟಿಕೇಟ್ ಕಾಯ್ದಿರಿಸಿದ ಪ್ರಯಾಣಿಕರ ಪೈಕಿ ಒಬ್ಬರು ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ಪ್ರಸ್ತುತಪಡಿಸಬೇಕಾದ ಮಾನ್ಯವಾದ ಗುರುತಿನ ಚೀಟಿಗಳು :- ಚಾಲನಾ ಪರವಾನಗಿ, ಚುನಾವಣೆ ಗುರುತಿನ ಚೀಟಿ, ಪಾನ್ ಕಾರ್ಡ್, ಪಾಸ್‌ಪೋರ್ಟ್, ಆಧಾರ್ ಕಾರ್ಡ್, ರೇಷನ್ ಕಾರ್ಡ್, ಹಿರಿಯ ನಾಗರಿಕರ ಗುರುತಿನ ಚೀಟಿ, ಪ್ರಯಾಣಿಕರ ಫೋಟೋ ಸಹಿತ ಗುರುತಿನ ಚೀಟಿಯ ಮೂಲ ಅಥವಾ ಛಾಯಾ ಪ್ರತಿ/ ಸರ್ಕಾರಿ ಇಲಾಖೆಗಳಿಂದ ಫೋಟೋ ಸಮೇತ ವಿತರಿಸಿರುವ ಮೂಲ ಗುರುತಿನ ಚೀಟಿ / ಖಾಸಗಿ ಕಂಪೆನಿಗಳಿಂದ ಫೋಟೋ ಸಮೇತ ವಿತರಿಸಿರುವ ಮೂಲ ಗುರುತಿನ ಚೀಟಿ/ ಶಿಕ್ಷಣ ಸಂಸ್ಥೆಗಳಿಂದ ಫೋಟೋ ಸಮೇತ ವಿತರಿಸಿರುವ ಮೂಲ ಗುರುತಿನ ಚೀಟಿ/ ಫೋಟೋ ಇರುವ ಮೂಲ ಡೆಬಿಟ್/ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ಗಳು, ಡಿಜಿಲಾಕರ್ ಆಪ್ ಮುಖಾಂತರ ಹಾಜರುಪಡಿಸುವ ಆಧಾರ್ ಕಾರ್ಡ್, ಪಾನ್‌ಕಾರ್ಡ್ ಹಾಗೂ ಚಾಲನಾ ಪರವಾನಗಿ ಗುರುತಿನ ಚೀಟಿ (ಸಾಫ್ಟ್ ಪ್ರತಿ) ಯನ್ನು ಗುರುತಿನ ಮಾನ್ಯ ಪುರಾವೆಯಾಗಿ ತೋರಿಸಬಹುದಾಗಿರುತ್ತದೆ.
            </div>
            <div className="node">
              Valid IDs to be presented during journey by one of the passenger booked on an e-ticket:- Driving License, Voter Identity Card, PAN Card, Passport, Aadhar, Ration Card, Senior Citizen card with photograph /Original Identity Card issued by the Government Departments with photo / Original with Photo identification card issued by Private Companies/ Original with photo Identity Card issued by the Education Institutions/ Original with Photo debit / credit cards/ Aadhaar, PAN Card and Driving License Identity (Soft Copy) presented through Digilocker App considered as valid proof of identity.
            </div>
          </div>
          <div className="imp-info">
            <h3>ವಿಶೇಷ ಸೂಚನೆಗಳು / Important information</h3>
            <ul>
              <li>
                <span>ಹೆಚ್ಚಿನ ವಿವರಗಳಿಗಾಗಿ <a href="www.ksrtc.in" style={{ color: "var(--ksrtcThColor1)", textDecoration: "underline" }}>www.ksrtc.in</a> ನಲ್ಲಿನ ಷರತ್ತು ಹಾಗೂ ನಿಬಂಧನೆಗಳನ್ನು ಅವಲೋಕಿಸಬಹುದಾಗಿದೆ.</span><br />
                <span>For details, rules and terms & conditions of E-Ticketing, please visit <a href="www.ksrtc.in" style={{ color: "var(--ksrtcThColor1)", textDecoration: "underline" }}>www.ksrtc.in</a></span>
              </li>
              <li>
                <span>ಈ ಟಿಕೇಟ್‍ನಲ್ಲಿ ಕಾಯ್ದಿರಿಸಿದ ಆಸನಗಳು ಇತರರಿಗೆ ವರ್ಗಾಯಿಸುವಂತಿಲ್ಲ.</span><br />
                <span>The seat(s) booked under this e-ticket/m-ticket is/are not transferable.</span>
              </li>
              <li>
                <span>ಇ-ಟಿಕೇಟ್/ಎಂ-ಟಿಕೇಟ್‌ನಲ್ಲಿ ನಮೂದಿಸಿರುವ ನಿರ್ದಿಷ್ಟ ಆಸನ ಸಂಖ್ಯೆ ಮತ್ತು ಬಸ್ಸು ಸೇವೆಗೆ ಮಾತ್ರ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ.</span><br />
                <span>This e-ticket/m-ticket is valid only for the seat number and bus service specified herein.</span>
              </li>
              <li>
                <span>ಗುರುತಿನ ಚೀಟಿಯನ್ನು ತೋರಿಸದಿದ್ದಲ್ಲಿ ಇ-ಟಿಕೇಟ್‍ನ್ನು “ಪ್ರಯಾಣಕ್ಕೆ ಯೋಗ್ಯವಲ್ಲದ ಟಿಕೇಟ್” ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ ಹಾಗೂ ಪ್ರಯಾಣಿಕರನ್ನು “ಟಿಕೇಟ್ ಇಲ್ಲದೇ ಇರುವ ಪ್ರಯಾಣಿಕರು” ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ. ಇಂತಹ ಪ್ರಕರಣಗಳಲ್ಲಿ ಪ್ರಯಾಣಿಕರು ಅದೇ ವಾಹನದಲ್ಲಿ ಪ್ರಯಾಣಿಸಲು ಇಚ್ಚಿಸಿದ್ದಲ್ಲಿ ಪೂರ್ಣ ಪ್ರಯಾಣದರ ಪಾವತಿಸಿ ನಿರ್ವಾಹಕರಿಂದ ಇಟಿಎಂ ಟಿಕೇಟ್ ಪಡೆದು ಪ್ರಯಾಣ ಮುಂದುವರೆಸಬಹುದಾಗಿರುತ್ತದೆ.</span><br />
                <span>E-ticket/m-ticket will become INVALID if the ID proof or e-ticket/m-ticket is not produced, and passengers will be treated as 'Ticketless Passengers.' If passengers wish to continue traveling on the same service, they can resume their journey by obtaining an ETM ticket from the conductor and paying the applicable fare.</span>
              </li>
              <li>
                <span>ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣ ಸಮಯದಲ್ಲಿ ಇ-ಟಿಕೇಟ್/ಎಂ-ಟಿಕೇಟ್ ಹಾಗೂ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಇಟ್ಟುಕೊಳ್ಳಬೇಕು.</span><br />
                <span>Passenger shall keep the e-ticket/m-ticket safely till the end of the journey.</span>
              </li>
              <li>
                <span>ತಪಾಸಣೆ ಸಂದರ್ಭದಲ್ಲಿ ಇ-ಟಿಕೇಟ್/ಎಂ-ಟಿಕೇಟ್ ಹಾಗೂ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಕಡ್ಡಾಯವಾಗಿ ತೋರಿಸುವುದು.</span><br />
                <span>Passenger shall show the e-ticket/m-ticket and ID proof at the time of checking.</span>
              </li>
              <li>
                <span>ಹಿರಿಯ ನಾಗರಿಕರ ರಿಯಾಯಿತಿಯು ಕರ್ನಾಟಕ ರಾಜ್ಯದ ನಿವಾಸಿಗಳಿಗೆ ಮಾತ್ರ ಅನ್ವಯಿಸುತ್ತದೆ ಮತ್ತು ಇತರೆ ರಾಜ್ಯದ ಹಿರಿಯ ನಾಗರಿಕರಿಗೆ ಅನ್ವಯಿಸುವುದಿಲ್ಲ. ಹಿರಿಯ ನಾಗರಿಕರ ರಿಯಾಯಿತಿ ಪಡೆದು ಪ್ರಯಾಣಿಸುತ್ತಿರುವ ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣದ ಸಂದರ್ಭದಲ್ಲಿ ಇ-ಟಿಕೆಟ್/ಎಂ-ಟಿಕೆಟ್ ನ ಜೊತೆಗೆ ಈ ಕೆಳಗೆ ತಿಳಿಸಿರುವ ಯಾವುದಾದರೊಂದು ಮೂಲ ಗುರುತಿನ ಚೀಟಿಯನ್ನು ಕಡ್ಡಾಯವಾಗಿ ತೋರಿಸುವುದು. ಚಾಲನಾ ಪರವಾನಗಿ, ಚುನಾವಣೆ ಗುರುತಿನ ಚೀಟಿ, ಪಾನ್ ಕಾರ್ಡ್, ಪಾಸ್‌ಪೋರ್ಟ್, ಆಧಾರ್ ಕಾರ್ಡ್, ರೇಷನ್ ಕಾರ್ಡ್, ಹಿರಿಯ ನಾಗರಿಕರ ಗುರುತಿನ ಚೀಟಿ ಪ್ರಯಾಣಿಕರ ಫೋಟೋ ಸಹಿತ ಗುರುತಿನ ಚೀಟಿಯ ಮೂಲ ಅಥವಾ ಛಾಯಾ ಪ್ರತಿ/ ಸರ್ಕಾರಿ ಇಲಾಖೆಗಳಿಂದ ಫೋಟೋ ಸಮೇತ ವಿತರಿಸಿರುವ ಮೂಲ ಗುರುತಿನ ಚೀಟಿ / ಕರ್ನಾಟಕ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ ನಿಗಮದಿಂದ ವಿತರಿಸಲ್ಪಟ್ಟ ಹಿರಿಯ ನಾಗರಿಕರ ಗುರುತಿನ ಚೀಟಿ/ ಡಿಜಿಲಾಕರ್ ಆಪ್ (Digilocker App) ಮುಖಾಂತರ ಹಾಜರುಪಡಿಸುವ ಆಧಾರ್ ಕಾರ್ಡ್, ಪಾನ್‌ಕಾರ್ಡ್ ಹಾಗೂ ಚಾಲನಾ ಪರವಾನಗಿ ಗುರುತಿನ ಚೀಟಿ (ಸಾಫ್ಟ್ ಪ್ರತಿ).</span><br />
                <span>Senior Citizen concession is applicable for residents of Karnataka State only. Residents of other states are not entitled for Senior Citizen concession. Passengers travelling with Senior Citizen concession need to produce any one of the following Original ID proof at the time of journey - Driving License, Voter Identity Card, PAN Card, Passport, Aadhar, Ration Card, Senior Citizen card with photograph /Original Identity Card issued by the Government Departments with photo / Senior citizen identity card issued by KSRTC / Aadhaar, PAN Card and Driving License Identity (Soft Copy) presented through Digilocker App considered as valid proof of identity...</span>
              </li>
              <li>
                <span>ಮುದ್ರಿತ ಇ-ಟಿಕೇಟ್ ನೊಂದಿಗೆ ನಿಗದಿತ ಗುರುತಿನ ಚೀಟಿ ಹೊಂದಿರುವ ಪ್ರಯಾಣಿಕರು, ಸದರಿ ಸಾರಿಗೆ ಹೊರಡುವ ಎರಡು ಗಂಟೆ ಮುಂಚಿನ ಅವಧಿಯಲ್ಲಿ ನಗರ ಸಾರಿಗೆ ಸೌಲಭ್ಯವನ್ನು ಉಚಿತವಾಗಿ ಪಡೆಯಬಹುದು (ಹವಾನಿಯಂತ್ರಿತ ಸಾರಿಗೆಗಳನ್ನು ಹೊರತುಪಡಿಸಿ). ಮೊಬೈಲ್ ಟಿಕೇಟ್ (SMS) ಆಧಾರದ ಮೇಲೆ ಉಚಿತ ನಗರ ಸಾರಿಗೆ ಸೌಲಭ್ಯವನ್ನು ನೀಡಲಾಗುವುದಿಲ್ಲ.</span><br />
                <span>Free Travel is permitted in City Buses (except A/C buses) within the City limits before 2 Hours of the departure time on production of e-ticket print-outs only. Free travel by showing m-ticket is not allowed.</span>
              </li>
              <li>
                <span>ಎಲ್ಲಾ ನಿರ್ಗಮನ / ಆಗಮನದ ಸಮಯಗಳು 24 ಗಂಟೆಯ ಸ್ವರೂಪದಲ್ಲಿರುತ್ತವೆ. ಅಂದರೆ 8:00 AM (ಬೆಳಿಗ್ಗೆ) ಅನ್ನು 08:00 ಗಂಟೆಗಳು ಮತ್ತು 8:00 PM (ರಾತ್ರಿ) ಅನ್ನು 20:00 ಗಂಟೆ ಎಂದು ನಮೂದಿಸಲಾಗುತ್ತದೆ.</span><br />
                <span>All departure / arrival timings are in 24 hour format i.e 8:00 AM will be displayed as 08:00 hrs and 8:00 PM as 20:00 hrs.</span>
              </li>
              <li>
                <span>ಬುಕ್ ಮಾಡಿದ ಟಿಕೇಟ್‍ನ ವಿವರಗಳು ತಪ್ಪಿದ್ದಲ್ಲಿ ರದ್ಧತಿಗೊಳಿಸಿ ಪುನಃ ಸರಿಯಾದ ವಿವರಗಳೊಂದಿಗೆ ಕಾಯ್ದಿರಿಸುವುದು. ಆನ್‍ಲೈನ್ ಇ-ಟಿಕೇಟ್/ಎಂ-ಟಿಕೇಟ್ ರದ್ಧತಿಗೊಳಿಸಿದ್ದಲ್ಲಿ ಅರ್ಹ ಮೊತ್ತವು ಸಂಬಂಧಪಟ್ಟ ಗ್ರಾಹಕರ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ಸಂದಾಯವಾಗಲಿದೆ. ನಗದು ಮೂಲಕ ಯಾವುದೇ ಕಾರಣಕ್ಕೂ ಹಿಂದಿರುಗಿಸಲಾಗುವುದಿಲ್ಲ.</span><br />
                <span>If booked e-ticket/m-ticket does not meet passenger requirements, user needs to cancel the ticket and rebook with correct details.Refunds for cancellation of online e-ticket/m-ticket will be made to customer's bank account only. Cash refunds are not allowed.</span>
              </li>
              <li>
                <span>ಆನ್‌ಲೈನ್‌ ಇ-ಟಿಕೇಟ್/ಎಂ-ಟಿಕೇಟ್‌ ರದ್ಧತಿ ಮಾಹಿತಿಯನ್ನು ಇ-ಮೇಲ್ ಮತ್ತು SMS ಮೂಲಕ ಖಚಿತಪಡಿಸಲಾಗುವುದು.</span><br />
                <span>Cancellation of online e-tickets/m-ticket by the user is confirmed through email and SMS.</span>
              </li>
              <li>
                <span>ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ಇ-ಟಿಕೇಟ್ / ಎಂ-ಟಿಕೇಟ್‍ಗಳನ್ನು ತೋರಿಸದಿದ್ದಲ್ಲಿ ಅಥವಾ ಪ್ರಯಾಣಕ್ಕೆ ಟಿಕೇಟ್ ಬಳಸದಿದ್ದಲ್ಲಿ ಯಾವುದೇ ಮರುಪಾವತಿಗೆ ಅವಕಾಶವಿರುವುದಿಲ್ಲ.</span><br />
                <span>No refund is allowed for Not-showing e-ticket/m-ticket or tickets not used for travel.</span>
              </li>
              <li>
                <span>ಪ್ರಯಾಣಿಕರು ವಾಹನ ನಿರ್ಗಮನಕ್ಕಿಂತ 10 ನಿಮಿಷ ಮುಂಚಿತವಾಗಿ ನಿಗದಿತ ಪ್ರಯಾಣಿಕರನ್ನು ಹತ್ತಿಸಿಕೊಳ್ಳುವ ಸ್ಥಳ ಪಿಕ್‍ಅಪ್ ಪಾಯಿಂಟ್‌ಗೆ ಆಗಮಿಸಲು ವಿನಂತಿಸಲಾಗಿದೆ.</span><br />
                <span>Passengers are requested to arrive at the Boarding / Pickup point at least 10 minutes before the scheduled time of departure of service.</span>
              </li>
              <li>
                <span>SMS ನ ವಿತರಣೆ (ಎಂ-ಟಿಕೇಟ್‌, ಟ್ರಿಪ್ ಶೀಟ್ ಮಾಹಿತಿ, ಸಾರಿಗೆ ಮಾಹಿತಿ ಇತ್ಯಾದಿ) ಬಳಕೆದಾರರ ಮೊಬೈಲ್ ಸೇವಾ ಪೂರೈಕೆದಾರರ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿರುತ್ತದೆ ಮತ್ತು ಕರಾರಸಾನಿಗಮವು SMS ವ್ಯತ್ಯಯಕ್ಕೆ ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ.</span><br />
                <span>Delivery of SMS (m-ticket, trip sheet alerts, service alerts etc.) Depends on mobile service provider of the user and KSRTC is not responsible for the delay/ discrepancy in SMS delivery.</span>
              </li>
              <li>
                <span>ಟಿಕೇಟ್‌ ರದ್ದುಪಡಿಸುವಲ್ಲಿ ಪ್ರಯಾಣಿಕರು ಯಾವುದೇ ಸಮಸ್ಯೆಯನ್ನು ಎದುರಿಸಿದರೆ ತಕ್ಷಣವೇ awatar@ksrtc.org ಗೆ ಇಮೇಲ್ ಮೂಲಕ ವರದಿ ಮಾಡಬೇಕಾಗುತ್ತದೆ. ಅಂತಹ ಮೇಲ್‌ಗಳನ್ನು ಮೇಲ್‌ನ ದಿನಾಂಕ ಮತ್ತು ಸಮಯದ ಆಧಾರದ ಮೇಲೆ ಮತ್ತು ಸೇವೆಯ ನಿರ್ಗಮನದ ಎರಡು ಗಂಟೆಗಳ ಮೊದಲು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ. ಅಂತಹ ಇಮೇಲ್ ಅನ್ನು ನೋಂದಾಯಿತ ಬಳಕೆದಾರ ಅಥವಾ ಅತಿಥಿ ಬಳಕೆದಾರ ಇಮೇಲ್ ಐಡಿಯಿಂದ ಮಾತ್ರ ಕಳುಹಿಸತಕ್ಕದ್ದು. ನಿಗದಿತ ಸಮಯದ ನಂತರ ಬೇರೆ ಇಮೇಲ್ ಐಡಿಯಿಂದ ಸ್ವೀಕರಿಸಿದ ಇಮೇಲ್‌ಗಳನ್ನು ಮರುಪಾವತಿಗಾಗಿ ಪರಿಗಣಿಸಲಾಗುವುದಿಲ್ಲ.</span><br />
                <span>If passenger faces any problem in cancellation of tickets, it needs to be reported by email to awatar@ksrtc.org, immediately. Such mails will be considered based on the date and time of the mail and upto two hours before the departure of the service. Such email shall be sent from registered user or guest user email id only. Mails received after this time or from different email id will not be considered for refund.</span>
              </li>
              <li>
                <span>ಪ್ರಯಾಣಿಕರು ತಮ್ಮ ಲಗ್ಗೇಜಿಗೆ ತಾವೇ ಜವಾಬ್ದಾರರು. ಪ್ರಯಾಣದ ಸಂದರ್ಭದಲ್ಲಾಗಲಿ/ವಾಹನದೊಳಗಾಗಲಿ ಪ್ರಯಾಣಿಕರ ಲಗ್ಗೇಜಿಗೆ ಕರಾರಸಾನಿಗಮವು ಜವಾಬ್ದಾರವಲ್ಲ.</span><br />
                <span>Any personal luggage or belongings should be taken care of by the passengers themselves.KSRTC is not responsible for passenger luggage / personal belongings inside the bus and during the journey.</span>
              </li>
              <li>
                <span>ಕರಾರಸಾ ನಿಗಮವು ತಪ್ಪು ಟಿಕೇಟ್ ಹೊಂದಿರುವ/ಸಹ ಪ್ರಯಾಣಿಕರಿಗೆ ತೊಂದರೆ ಕೊಡುವ ಹಾಗೂ ಮಧ್ಯಪಾನ ಮಾಡಿದಪ್ರಯಾಣಿಕರನ್ನು, ಪ್ರಯಾಣದರ ಮರುಪಾವತಿ ಇಲ್ಲದೇ ಇಳಿಸುವ ಹಕ್ಕನ್ನು ಹೊಂದಿದೆ.</span><br />
                <span>KSRTC reserves the right to off-load passengers who are travelling on incorrect tickets, disturbing co-passengers and also drunken passengers without refund of fare.</span>
              </li>
              <li>
                <span>ಬಸ್ಸಿನಲ್ಲಿ ಧೂಮಪಾನ ಹಾಗೂ ಮಧ್ಯಪಾನ ಮಾಡುವುದನ್ನು ನಿಷೇಧಿಸಲಾಗಿದೆ.</span><br />
                <span>Smoking and consumption of alcohol is strictly prohibited inside the bus</span>
              </li>
              <li>
                <span>ನಿಗಮವು ಸಾರಿಗೆಯನ್ನು ರದ್ದುಪಡಿಸುವ ಅಥವಾ ವರ್ಗ ಬದಲಾಯಿಸುವ ಹಕ್ಕನ್ನು ಕಾಯ್ದಿರಿಸಿದೆ.</span><br />
                <span>Corporation reserves the rights to change/cancel the service.</span>
              </li>
              <li>
                <span>ಸೂಚನೆ: ಬಳಕೆದಾರರು 'ಯಾವುದೇ ಸಂಸ್ಥೆಯ ಯಾವುದೇ ವ್ಯಕ್ತಿಗೆ ತಮ್ಮ ಆನ್‌ಲೈನ್ ಬ್ಯಾಂಕಿಂಗ್ / ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ / ಡೆಬಿಟ್ ಕಾರ್ಡ್ ವಿವರಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಬೇಡಿ' ಎಂದು ವಿನಂತಿಸಲಾಗಿದೆ. ವಿಚಾರಣೆಗಾಗಿ ಕಾಲ್ ಸೆಂಟರ್ 080-26252625</span><br />
                <span>All users are requested 'Not to share their online banking / Credit card / Debit card details to any person from any organization. Enquiry 080-26252625.</span>
              </li>
            </ul>
          </div>
          <div className="bottum">
            <div>ಕಾಯ್ದಿರಿಸಿದವರ ಹೆಸರು / Booked By: {viewBookingData.PassengerEmail}</div>
            <div>ಯಾವಾಗ ಕಾಯ್ದಿರಿಸಿದ್ದು / Booked On: {viewBookingData.BookingDate && getDateFormatIPhone(viewBookingData.BookingDate, "DD-MMM-YYYY HH:mm")}</div>
          </div>
          <div className="bottum-single">
            <p>ಪ್ರಯಾಣ ಸುಖಕರವಾಗಿರಲಿ / WISH YOU HAPPY JOURNEY</p>
          </div>
        </>
        )}

        <div className="bottom-buttons">
          {/* <button onClick={print}>Print</button> */}
          {type === "" && <button onClick={() => handelSendTicket(viewBookingData,viewBookingData.PassengerContactNo1)}>send SMS Email</button>}
          <button>
            <a href={`/ticket/download/${token}`} target="_blank"> download ticket </a>
          </button>
          {/* <button onClick={() => bookAgain(viewBookingData)}>book again</button> */}
        </div>

      </div>
      {emailSuccess && <AlertSuccess
        msg={
          <div
            className="tnc-block-text"
            style={{ justifyContent: "center" }}
          >
            <div className="icon">
              {renderImg('success_icon')}
            </div>
            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
              We have sent your ticket information on Email ID
            </div>
          </div>
        }
        type={"sendEmail"}
        close={() => setEmailSuccess(false)}
      />}

      {emailFailed && <AlertFail
        msg={
          <div
            className="tnc-block-text"
            style={{ justifyContent: "center" }}
          >
            <div className="icon">
              {renderImg('fail_icon')}
            </div>
            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
              Something went wrong
            </div>
          </div>
        }
        close={() => setEmailFailed(false)}
        type={"sendEmail"}
      />}

      {linkTicketMsg && <AlertFail
        msg={
          <div
            className="tnc-block-text"
            style={{ justifyContent: "center" }}
          >
            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
              This is Link ticket PNR, you can retrieve the other Link PNR as well
            </div>
          </div>
        }
        btnText="OK"
        onClose={() => setLinkTicketMsg(false)}
      />}
    </>
  )
}

export default ViewBooking